import { CommunityId, ObservationKind } from "@sp-crm/core";
import React from "react";
import { CommunityRequestListingUpdatePanel } from "./community-request-listing-update-panel";

interface Props {
    communityId: CommunityId;
    communityName: string;
    onDismiss: () => void;
    onSuccess: () => void;
}

export const CommunityRequestPricingUpdatePanel: React.FC<Props> = props => {
    const { communityId, communityName, onDismiss, onSuccess } = props;

    return (
        <CommunityRequestListingUpdatePanel
            communityId={communityId}
            communityName={communityName}
            onDismiss={onDismiss}
            onSuccess={onSuccess}
            body={`Hi!<br><br>Could you share your current pricing information? You can use the link below to update your pricing details.<br><br>{{link}}<br><br>Thanks for keeping us in the loop!`}
            subject="Quick question about pricing"
            observationFocus={ObservationKind.Pricing}
        />
    );
};
